import React, { Component } from 'react';
import ReactDOM from 'react-dom';

class Dfp extends Component {

	 constructor(props){
		  super(props);
		  this.state = {adunit:''};

			this.adUnit = '';
			this.slotId = 'ad_' + Math.floor(Math.random()*89999+10000);

		  if(props.hasOwnProperty('dfpUpdate')){
              props.dfpUpdate();
		  }
	 }

	 componentDidMount(){
		// TODO : remove this line of Temporary log for testing only
		// console.log('advert-props', this.newAdvertProps()['data-advert-props'], this.props.adUnit);

	 	const { dfpReady } = this.props
		let that = this;
		const googletag = window.googletag;

		 if(ReactDOM.findDOMNode(this).childNodes[0].id !== '') {
			 googletag.cmd.push(() => {
				const {adUnit: adUnitCode, sizes, sizeMapping, targeting, callback} = this.props;
				const {slotId} = this;
				let sizeMapBuilder = googletag.sizeMapping();

				const adUnit = googletag.defineSlot('/1038353/' + adUnitCode, sizes, slotId).addService(googletag.pubads());
				this.adUnit = adUnit;

				if(typeof sizeMapping !== 'undefined' && sizeMapping.length){
					for(var smIdx = 0; smIdx < sizeMapping.length; smIdx++){
						sizeMapBuilder.addSize(sizeMapping[smIdx].viewport,sizeMapping[smIdx].sizes);
					}
					adUnit.defineSizeMapping(sizeMapBuilder.build());
				}
				if(typeof targeting !== 'undefined' && targeting.length){
					for(var tIdx = 0; tIdx<targeting.length; tIdx++){
						adUnit.setTargeting(targeting[tIdx].key,targeting[tIdx].value);
					}
				}
				googletag.display(slotId);

				if(typeof dfpReady == 'function'){
                    dfpReady(adUnit)
				}
				else{
                    googletag.pubads().refresh([adUnit]);
                }

				// googletag.pubads().refresh([adUnit]);
				if(typeof callback === 'function') {
					googletag.pubads().addEventListener('slotRenderEnded', event =>{
						callback(event, this.adUnit);
					});
				}
			});
		}
	}

	componentWillUnmount () {
		googletag.destroySlots([this.slotId]);
	}

	 newAdvertProps () {
		 const {theme, page, position, tag} = this.props;
		 const advertProps = {'data-ad-position': position};
		 if (typeof theme === 'string' && typeof page === 'string' && typeof position === 'string') {
			 advertProps['data-advert-props'] = [theme, page, position, tag].filter(Boolean).join(',');
		 }
		 return advertProps;
	 }

	render() {
		const {dfpRef} = this.props;
		const {slotId} = this;
		return (
			<div className="dfp-slot text-center" ref={dfpRef}>
				<div {...this.newAdvertProps()} id={this.slotId}></div>
			</div>
		)
	}
}

export default Dfp;



// WEBPACK FOOTER //
// ./src/Dfp.js